"use client";

import Link from "next/link";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function NavigationPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2 max-w-3xl w-full">
        {/* Rendering Section */}
        <Card className="hover:shadow-md transition-shadow rounded-xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">渲染技术研究</CardTitle>
            <CardDescription className="text-sm">
              使用 Drei 材质
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" asChild>
              <Link href="/rendering">进入技术对比</Link>
            </Button>
          </CardContent>
        </Card>

        {/* Legacy Rendering Section */}
        <Card className="hover:shadow-md transition-shadow rounded-xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">渲染技术研究（Legacy）</CardTitle>
            <CardDescription className="text-sm">
              PBR、Ray Tracing、Ray Marching
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" asChild>
              <Link href="/legacy-rendering">进入技术对比</Link>
            </Button>
          </CardContent>
        </Card>

        {/* Sticker Section */}
        <Card className="hover:shadow-md transition-shadow rounded-xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">贴纸定制预览</CardTitle>
            <CardDescription className="text-sm">
              专业的 3D 贴纸可视化工具
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" asChild>
              <Link href="/sticker">进入贴纸定制</Link>
            </Button>
          </CardContent>
        </Card>

        {/* Navigation Back to Home */}
        <Card className="hover:shadow-md transition-shadow rounded-xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">激光内雕定制</CardTitle>
            <CardDescription className="text-sm">
              产品化的激光内雕服务
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full" asChild>
              <Link href="/">返回首页</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}